/** biome-ignore-all lint/suspicious/noArrayIndexKey: suppressed */
"use client";

import { ChevronRight } from "lucide-react";
import { usePathname } from "next/navigation";
import { Fragment } from "react";
import type { MenuItem } from "@/config/types";
import { useBreadcrumbContext } from "@/contexts/breadcrumb-context";
import { useMenu } from "@/hooks/use-menu";
import useMenuConfig from "@/hooks/use-menu-config";
import { cn } from "@/lib/utils";

export function Breadcrumb() {
	const pathname = usePathname();
	const menuSidebar = useMenuConfig();
	const { getBreadcrumb, isActive } = useMenu(pathname || "");
	const { customBreadcrumbTitle } = useBreadcrumbContext();
	let items: MenuItem[] = getBreadcrumb(menuSidebar);

	// Detail pages override the last crumb with the entity name.
	if (customBreadcrumbTitle && items.length > 0) {
		items = [
			...items.slice(0, -1),
			{ ...items[items.length - 1], title: customBreadcrumbTitle },
		];
	}

	if (items.length === 0) {
		return null;
	}

	return (
		<div className="flex items-center gap-1.25 text-xs lg:text-sm font-medium mb-2.5 lg:mb-0">
			{items.map((item, index) => {
				const last = index === items.length - 1;
				const active = item.path ? isActive(item.path) : false;

				return (
					<Fragment key={`root-${index}`}>
						<span
							className={cn(active ? "text-mono" : "text-secondary-foreground")}
							key={`item-${index}`}
						>
							{item.title}
						</span>
						{!last && (
							<ChevronRight
								className="size-3.5 text-muted-foreground"
								key={`separator-${index}`}
							/>
						)}
					</Fragment>
				);
			})}
		</div>
	);
}
